<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <el-input v-model="objr.keyword" style="width:200px;margin-right:10px" placeholder="请输入内容" @input="awered" />
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="sraw">搜索</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addbit">新增biz</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="appid"
        label="appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="biz"
        label="biz名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="phone_name"
        label="手机编码"
        width="180"
        align="center"
      />
      <el-table-column
        prop="phone_vx_account"
        label="个人微信号"
        width="180"
        align="center"
      />

      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      :title="adtype === 1 ? '新增biz设置' : '编辑biz设置'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
    >
      <bitdialog ref="addbiz" @updatawe="updatawe" />
    </el-dialog>
  </div>
</template>

<script>
import bitdialog from './components/bitdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getbizlist } from '@/api/sourceMaterial.js'
export default {
  components: {
    bitdialog,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        pageSize: 10,
        keyword: null
      },
      adtype: null,
      newtotalr: null,
      tableData: []
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  methods: {
    async menuList() {
      // 获取列表
      const data = await getbizlist(this.objr)
      console.log('data', data)
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      if (this.objr.keyword === '') {
        this.objr.page = 1
        this.objr.pageSize = 10
        this.objr.keyword = null
        this.menuList()
      }
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addbiz.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addbiz.send(2, item)
      }, 100)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box{
  padding: 20px;
}
.search_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
